export default __webpack_public_path__ + "static/media/topmark.21d308bc.png";